.button {
	background-color: var(--primary);
	color: var(--textSecondary);
	width: fit-content;
	height: fit-content;
	padding: 0.5rem 1rem;
	border-radius: var(--rounded);
	font-weight: 600;
	transition-duration: var(--transitionSpeedFast);
	transition-property: color, background-color;
	cursor: pointer;
}
.button:hover {
	background-color: var(--primaryHover);
	transition-duration: var(--transitionSpeedFast);
}
.button:disabled,
button:disabled:hover {
	background-color: var(--primaryDisabled);
	color: var(--textSecondaryDisabled);
	cursor: not-allowed;
	border: none;
	outline: none;
}
